import { useParams } from 'react-router-dom';
import { experienceDetails } from '../../contants';

import DetailsComponent from './DetailsComponent';
import styled from 'styled-components';

const ExperienceDetails = () => {
  const { companyName } = useParams();
  const companyDetails = experienceDetails.find(
    (item) => item.companyName === companyName
  );

  return (
    <DetailsComponent>
      <Wrapper>
        <Header>{companyDetails.companyName}</Header>
        <Info>
          <p>{companyDetails.title}</p>
        </Info>
        <Tags>
          {companyDetails.technologies.map((item, index) => (
            <Tag key={index}>{item}</Tag>
          ))}
        </Tags>
      </Wrapper>
      <Description>
        <ul>
          {companyDetails.description.map((points, index) => (
            <List key={index}>{points}</List>
          ))}
        </ul>
      </Description>
    </DetailsComponent>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const Header = styled.h1`
  font-family: 'Bashing';
  font-size: calc(70 / 16 * 1rem);
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  margin-bottom: 8px;
  line-height: 68px;
`;

const Info = styled.div`
  display: flex;
  font-family: 'Raleway';
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 24px;
  display: flex;
  gap: 16px;
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
`;

const Tag = styled.p`
  background-color: ${({ theme }) => theme.tileBackground};
  height: 36px;
  letter-spacing: 0.5px;
  font-family: 'Raleway';
  font-size: 16px;
  width: fit-content;
  padding: 8px;
  border-radius: 36px;
  display: flex;
  align-items: center;
`;

const Description = styled.div`
  flex: 1;
  font-family: 'Raleway';
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  text-align: left;
`;

const List = styled.ul`
  margin-bottom: 16px;
  font-family: 'Raleway';
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 26px;
`;

export default ExperienceDetails;
